import React, { useState } from "react"
import axios from 'axios';
import { CheckCircleIcon, XCircleIcon } from '@heroicons/react/solid'

export default function ContactForm({props}) {

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: ""
  });
  const [formSuccess, setFormSuccess] = useState(false)
  const [formError, setFormError] = useState(false)
  const [errorMessage, setErrorMessage] = useState("There was a problem sending your message. Please try again later.")
  const [submitDisabled, setSubmitDisabled] = useState(false)

  const handleInput = (e) => {
    const fieldName = e.target.name;
    const fieldValue = e.target.value;
    setFormError(false);
    setFormData((prevState) => ({
      ...prevState,
      [fieldName]: fieldValue
    }));
  }

  const ShowSuccess = () => {
    return (
      <div className="bg-white p-4">
        <div className="flex">
          <div className="flex-shrink-0">
            <CheckCircleIcon className="h-5 w-5" aria-hidden="true" />
          </div>
          <div className="ml-3">
            <h3 className=" text-sm font-medium text-green-800">Your message was sent successfully. Thank you.</h3>
          </div>
        </div>
      </div>
    )
  }

  const ShowError = () => {
    return (
      <div className="bg-white p-4">
        <div className="flex">
          <div className="flex-shrink-0">
            <XCircleIcon className="h-5 w-5 text-red-400" aria-hidden="true" />
          </div>
          <div className="ml-3">
            <h3 className="text-sm font-medium text-red-800">{errorMessage}</h3>
          </div>
        </div>
      </div>
    )
  }

  const submitForm = (e) => {
    e.preventDefault()
    setFormSuccess(false);
    setFormError(false);

    // validate input
    let exit_proc = false
    Object.entries(formData).forEach(([key, value]) => {
      if (!value) {
        setErrorMessage("Please enter valid values for all fields");
        setFormError(true);
        exit_proc = true;
      }
      if (key == 'email') {
        if (!value.toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/))
        {
          setErrorMessage("Please enter a valid email");
          setFormError(true);
          exit_proc = true;
        }
      }
    });
    if (exit_proc) return;

    // set email body
    let message = `
Name: ${formData.name}

Email: ${formData.email}

Subject: ${formData.subject}

Message:

${formData.message}
    `
    let coachName = props.name;
    // coachName = 'George'; // for testing
    const data = { coach_name: coachName, message: message }
    setSubmitDisabled(true);
    let config = {
      headers: {
        "Content-Type": "application/json",
      }
    }
    // axios.post('http://localhost:3394' +'/forward_mail_from_trader_coach', data).then(response => {
    axios.post('https://app.forexanalytix.com' +'/forward_mail_from_trader_coach', data, config).then(response => {
      setFormData({
        name: "",
        email: "",
        subject: "",
        message: ""
      });
      setFormSuccess(true);
      setFormError(false);
      setSubmitDisabled(false);
    }).catch(error => {
      setErrorMessage("There was a problem sending your message. Please try again later.");
      setFormError(true);
      setFormSuccess(false);
      setSubmitDisabled(false);
    });
  }

  return (
    <div className="bg-green-400 p-5">
      <div className="grid sm:grid-cols-2 text-md gap-16 my-6 mx-auto max-w-4xl items-start">
        <div>
          <h1 className="text-3xl font-extrabold">{props.lng == 'esp' ? "Hablemos" : "Let's Talk"}</h1>
          <p className="text-md  mt-3">
          {props.lng == 'esp' ?
              "¿Tiene alguna pregunta sobre la mentoría y entrenamiento de trading con " + props.name + "? Entonces comuníquese con él, le encantaría conocer su caso y brindarle ayuda."
           :
          "Do you have any questions about " + props.name + "'s trading coaching? Then reach out, he'd love to hear about your case and provide help."}
          </p>

          <div className="mt-12">
            <h2 className="text-lg font-extrabold">Socials</h2>
            <ul className="flex mt-3 space-x-4">
              <li className="bg-black h-12 w-12 rounded-full flex items-center justify-center shrink-0">
                <a href={"https://twitter.com/" + props.twitter} target="_blank" rel="noopener noreferrer">
                  <span className="sr-only">Twitter</span>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor" className="h-6 w-6 text-green-400 hover:text-white">
                    <path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z" />
                  </svg>
                </a>
              </li>
            </ul>
          </div>

        </div>
        <form method="post" onSubmit={submitForm} className="ml-auo space-y-4">
          <input type='hidden' name="mentor" value={props.name} />
          <input type='text' placeholder='Name' name="name" onChange={handleInput} value={formData.name}
            className="mr-2 w-full px-6 py-3 border border-transparent placeholder-gray-600  focus:ring-offset-black focus:border-black  focus:ring-black" />
          <input type='email' placeholder='Email' name="email" onChange={handleInput} value={formData.email}
            className="mr-2 w-full px-6 py-3 border border-transparent placeholder-gray-600  focus:ring-offset-black focus:border-black  focus:ring-black" />
          <input type='text' placeholder='Subject' name="subject" onChange={handleInput} value={formData.subject}
            className="mr-2 w-full px-6 py-3 border border-transparent placeholder-gray-600  focus:ring-offset-black focus:border-black  focus:ring-black" />
          <textarea placeholder='Message' rows="6" name="message" onChange={handleInput} value={formData.message}
            className="mr-2 w-full px-6 py-3 border border-transparent placeholder-gray-600  focus:ring-offset-black focus:border-black  focus:ring-black"
          >
          </textarea>
          <button
            disabled={submitDisabled}
            type="submit"
            className="rounded-full w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-bold text-white bg-gray-900 hover:text-green-400 md:py-4 md:text-lg md:px-10"
          >
            {submitDisabled ? "Please wait ..." : props.lng == 'esp' ? "Enviar" : "Send"}
            </button>
          {formSuccess ? <ShowSuccess /> : ""}
          {formError ? <ShowError /> : ""}
        </form>

      </div>
    </div>
  )
}
